import React, { useEffect, useState } from 'react';

// 8 product tile images uploaded to Bunny CDN. Split from the two provided collages.
const TILES = [
    { src: 'https://dharmikpull.b-cdn.net/banners/82439307c8614a15acdd779ce18b78ec.jpg', label: 'Bonsai' },
    { src: 'https://dharmikpull.b-cdn.net/banners/dc8d953d365c44e1838e64230b5e29cc.jpg', label: 'Ceramic Pot' },
    { src: 'https://dharmikpull.b-cdn.net/banners/a7b073745de44123bb8120365881c274.jpg', label: 'Terracotta' },
    { src: 'https://dharmikpull.b-cdn.net/banners/c237a24d90c54a629cb95732ae16c873.jpg', label: 'Garden Tools' },
    { src: 'https://dharmikpull.b-cdn.net/banners/f58e367b8f7b437abe4e13cec54d554b.jpg', label: 'Floral Vase' },
    { src: 'https://dharmikpull.b-cdn.net/banners/ce9e3ecb36fb487d9c5a200128e94f56.jpg', label: 'Pebbles' },
    { src: 'https://dharmikpull.b-cdn.net/banners/a7fd2f9d2d594bf89a78669d3fa4aefd.jpg', label: 'Tool Bag' },
    { src: 'https://dharmikpull.b-cdn.net/banners/29aeff048adf47c6b292d69d912d8c61.jpg', label: 'Zen Stack' },
];

// Final "settled" positions inside the 460px×420px stage (top,left,rotate,size).
// Arranged as an artful scatter — no two cards perfectly aligned.
const SPOTS = [
    { top: '4%', left: '12%', rotate: -8, w: 200, h: 244, delay: 0.0, dir: 'top' },       // Bonsai
    { top: '6%', left: '54%', rotate: 6, w: 160, h: 160, delay: 0.35, dir: 'right' },     // Pot
    { top: '48%', left: '4%', rotate: -4, w: 158, h: 148, delay: 0.7, dir: 'left' },      // Terracotta
    { top: '38%', left: '58%', rotate: 8, w: 170, h: 138, delay: 1.05, dir: 'top' },      // Tools
    { top: '2%', left: '38%', rotate: -3, w: 130, h: 158, delay: 1.4, dir: 'top' },       // Flowers
    { top: '54%', left: '28%', rotate: 5, w: 150, h: 128, delay: 1.75, dir: 'bottom' },   // Pebbles
    { top: '68%', left: '55%', rotate: -6, w: 160, h: 128, delay: 2.1, dir: 'right' },    // Tool bag
    { top: '30%', left: '32%', rotate: 2, w: 130, h: 130, delay: 2.45, dir: 'bottom' },   // Zen
];

// Loop the animation every 5s (2.9s to land the last card + ~2.1s settle before restart)
const LOOP_MS = 5000;

// Off-screen starting transforms per direction
function startTransform(dir) {
    switch (dir) {
        case 'top': return 'translate(0, -140%) rotate(-30deg) scale(0.6)';
        case 'right': return 'translate(140%, 0) rotate(25deg) scale(0.6)';
        case 'bottom': return 'translate(0, 140%) rotate(30deg) scale(0.6)';
        case 'left': return 'translate(-140%, 0) rotate(-25deg) scale(0.6)';
        default: return 'translate(0, -140%) rotate(-30deg) scale(0.6)';
    }
}

export default function HeroCollage() {
    // key changes to force restart of CSS animations
    const [cycle, setCycle] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setCycle(c => c + 1), LOOP_MS);
        return () => clearInterval(t);
    }, []);

    return (
        <div
            className="relative select-none pointer-events-none"
            style={{ width: 460, height: 420 }}
            aria-hidden="true"
            data-testid="hero-collage"
        >
            {/* Soft ambient glow behind the scatter */}
            <div
                className="absolute rounded-full blur-3xl"
                style={{
                    width: 380, height: 380, top: '10%', left: '15%',
                    background: 'radial-gradient(circle, rgba(74,222,128,0.35) 0%, rgba(74,222,128,0) 70%)',
                }}
            />
            {TILES.map((tile, i) => {
                const s = SPOTS[i];
                return (
                    <div
                        key={`${cycle}-${i}`}
                        className="absolute rounded-xl overflow-hidden shadow-2xl ring-1 ring-white/30 dg-hero-tile"
                        style={{
                            width: s.w, height: s.h,
                            top: s.top, left: s.left,
                            animationDelay: `${s.delay}s`,
                            '--dg-from': startTransform(s.dir),
                            '--dg-to': `translate(0, 0) rotate(${s.rotate}deg) scale(1)`,
                        }}
                        data-testid={`hero-tile-${tile.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                        <img
                            src={tile.src}
                            alt={tile.label}
                            className="h-full w-full object-cover"
                            draggable={false}
                            loading="eager"
                        />
                        {/* subtle inner border */}
                        <div className="absolute inset-0 rounded-xl ring-2 ring-white/40 pointer-events-none" />
                    </div>
                );
            })}
        </div>
    );
}
